import {get,post} from './httpApi';
import {getShopId, getUserId} from "../utils/auth";

/*获取全部分類*/
export function getIndexTypeAll(data){
    return get('/goods/noJwt/getIndexTypeAll',{
        ...data,
    })
}
/*获取商品一级分類*/
export function getIndexOneType(data){
    return get('/goods/noJwt/getIndexOneType',{
        ...data
    })
}
/*显示所有商品-傳SHOPID即查詢店鋪商品*/
export function findByShopIdForShop(data){
    return get('/goods/noJwt/findByShopIdForShop',{
        ...data
    })
}
/*商品详情詳情*/
export function findGoodsInfoById(data){
    let params = data;
    if(getUserId()){
        params.userId=getUserId()
    }
    return get('/goods/noJwt/findGoodsInfoById',params)
}
/*商品全部出价列表*/
export function getAuctionPageForGoods(data){
    return get('/goods/noJwt/getAuctionPageForGoods',{
        ...data
    })
}
/*参与出价*/
export function addAuctionForUser(data){
    return post('/goods/addAuctionForUser',{
        ...data
    })
}

/*添加评价*/
export function addEvaluate(data){
    return post('/goodsEvaluate/addEvaluate',{
        ...data
    })
}

/*店铺取消竞拍*/
export function cancelEndForShop(data){
    return post('/goods/cancelEndForShop',{
        ...data
    })
}
/**
 * 店铺取消竞拍
 * @param:ACCESS_TOKEN 令牌
 * @param:goodsId 商品ID
 * @param:shopId 店铺ID
 * */
export function auctionEndForShop(data){
    return post('/goods/auctionEndForShop',{
        ...data
    })
}
/**
 * 上下架商品
 * @param:ACCESS_TOKEN 令牌
 * @param:goodsId 商品ID
 * @param:shopId 店铺ID
 * @param:status 狀態 1上架0下架
 * */
export function upDownGoods(data){
    return post('/goods/upDownGoods',{
        ...data,
        shopId:getShopId()
    })
}
/**
 * 新增商品
 * @param:shopId 店铺ID
 * @param:goodsName 商品名稱
 * @param:goodsLog 商品縮略圖
 * @param:goodsImg 商品滚动圖片
 * @param:goodsDesc 商品描述
 * @param:goodsInfoImg 商品详情长图
 * @param:sizeName 规格名称
 * @param:goodsVideo 商品视频
 * @param:oneTypeId 一级分類ID
 * @param:twoTypeId 二级分類ID
 * @param:addPrice 加价幅度
 * @param:onePrice 一口价
 * @param:startPrice 起拍价
 * @param:price 普通商品售价
 * @param:distributionFee 运费
 * @param:stock 商品库存
 * @param:overTime 到期时间
 * @param:newsId 关联新闻ID
 * @param:goodsType 商品类型1普通商品 2视频商品 3竞拍商品 4直播商品
 * @param:ACCESS_TOKEN 令牌
 * */
export function addGoods(data){
    return post('/goods/addGoods',{
        ...data,
        shopId:getShopId()
    })
}

export function editGoods(data){
    return post('/goods/editGoods',{
        ...data,
        shopId:getShopId()
    })
}

//
export function delGoodsForShop(goodsId){
    return post('/goods/delGoodsForShop',{
        goodsId,
        shopId:getShopId()
    })
}